import { LoadingOutlined } from '@ant-design/icons';

export const Loading = () => <LoadingOutlined spin />;
